<template>
  <div ref="drawer-wrapper">
    <v-navigation-drawer
      fixed
      class="v-navv"
      dark
      app
      persistent
      color="#00ACDC"
      :clipped="clipped"
      v-model="drawer"
      enable-resize-watcher
    >
      <v-img
        class="mx-auto mt-3"
        max-height="200"
        :max-width="maxWidth"
        :src="logoW"
      />
      <v-list-item two-line>
        <v-list-item-avatar>
          <v-icon
            dark
            large
          >
            mdi-account
          </v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <!-- <v-list-item-title>
          {{ this.username }}
        </v-list-item-title> -->
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-list-item-title
                v-bind="attrs"
                v-on="on"
                v-text="username"
              />
            </template>
            <span>{{ this.$store.state.name.toUpperCase() }}</span>
          </v-tooltip>
          <v-list-item-subtitle>
            {{ companyName }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider />

      <v-list nav>
        <!-- <v-list-item
          router
          class="body-2"
          :to="item.to"
          :key="i"
          :disabled="item.disabled"
          v-for="(item, i) in schedule_menu"
          exact
        >
          <v-list-item-icon>
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="item.title"></v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->

        <v-list-group
          :value="false"
          prepend-icon="mdi-calendar-blank"
          no-action
          dark
          color="white"
          v-model="model"
        >
          <template #activator>
            <v-list-item-title>Booking</v-list-item-title>
          </template>
          <!-- eslint-disable vue/no-use-v-if-with-v-for -->
          <v-list-item
            router
            class="body-2"
            :to="item.to"
            :key="i"
            :disabled="item.disabled"
            v-for="(item, i) in booking_group_items"
            exact
            v-if="showThisPage(item)"
          >
            <v-list-item-title v-text="item.title" />

            <v-list-item-icon>
              <v-badge
                color="primary accent-4"
                :content="getRequest"
                right
                overlap
                v-if="item.to === '/request' && getRequest > 0"
              >
                <v-icon v-text="item.icon" />
              </v-badge>
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>

        <v-list-item
          router
          class="body-2"
          :to="item.to"
          :key="item.title"
          :disabled="item.disabled"
          v-for="item in filteredItems"
          exact
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-group
          :value="false"
          prepend-icon="mdi-account"
          no-action
          dark
          color="white"
          v-if="userType == 1 || userType == 3 || userType == 4"
        >
          <template #activator>
            <v-list-item-title>User</v-list-item-title>
          </template>
          <v-list-item
            router
            class="body-2"
            :to="item.to"
            :key="i"
            :disabled="item.disabled"
            v-for="(item, i) in user_group_items"
            exact
          >
            <v-list-item-title v-text="item.title" />

            <v-list-item-icon>
              <v-badge
                color="primary accent-4"
                :content="userTotal"
                right
                overlap
                v-if="item.to === '/user_approval'"
              >
                <v-icon v-text="item.icon" />
              </v-badge>
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>

        <v-list-group
          :value="false"
          prepend-icon="mdi-application"
          no-action
          dark
          color="white"
          v-if="userType == 1 || userType == 3"
        >
          <template #activator>
            <v-list-item-title>Asset</v-list-item-title>
          </template>
          <v-list-item
            router
            class="body-2"
            :to="item.to"
            :key="i"
            :disabled="item.disabled"
            v-for="(item, i) in asset_group_items"
            exact
          >
            <v-list-item-title v-text="item.title" />

            <v-list-item-icon>
              <v-icon v-text="item.icon" />
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      id="core-app-bar"
      app
      flat
      color="transparent"
      absolute
      elevate-on-scroll
      class="elevation-2"
      height="72"
      :clipped-left="clipped"
    >
      <v-toolbar-title
        class="tertiary--text font-weight-light align-self-center mx-0"
      >
        <v-btn
          v-if="drawer"
          dark
          icon
          color="#00ACDC"
          @click.stop="drawer = !drawer"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn
          v-if="!drawer"
          dark
          icon
          color="#00ACDC"
          @click.stop="drawer = true"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        {{ title }}
      </v-toolbar-title>

      <v-spacer />

      <v-toolbar-items>
        <v-row
          align="center"
          class="mr-4"
        >
          <v-menu offset-y>
            <template #activator="{ on }">
              <v-btn
                color="#00ACDC"
                dark
                fab
                small
                text
                v-on="on"
              >
                <v-icon>
                  mdi-account
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="myProfile">
                <v-list-item-title>My profile</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="!isSSO"
                @click="() => {
                  isError = false;
                  dialog = true;
                }"
              >
                <v-list-item-title>Change password</v-list-item-title>
              </v-list-item>
              <v-list-item @click="logout">
                <v-list-item-title>Logout</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-dialog
            v-model="dialog"
            max-width="500px"
            persistent
          >
            <v-card outlined>
              <v-toolbar
                light
                flat
              >
                <v-spacer />
                <div class="pt-3">
                  <p class="text-center headline">
                    <v-icon
                      color="#00ACDC"
                      class="mx-2"
                    >
                      mdi-lock-reset
                    </v-icon>Change {{ changeDefaultPassword ? 'default ' : '' }}password
                  </p>
                </div>
                <div class="flex-grow-1" />
              </v-toolbar>
              <v-alert
                v-model="isError"
                type="error"
                dismissible
                class="mx-4 mb-2"
              >
                {{ this.errorMessage }}
              </v-alert>
              <v-card-text class="my-0">
                <p v-if="changeDefaultPassword">
                  You are still using the password generated by system. Please change your password.
                </p>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-container>
                    <v-text-field
                      outlined
                      color="success"
                      label="Current password"
                      v-model="currentPassword"
                      :rules="currentPasswordRules"
                      required
                      type="password"
                    />

                    <v-text-field
                      outlined
                      color="success"
                      label="New password"
                      v-model="newPassword"
                      :rules="passwordRules"
                      required
                      type="password"
                    />
                    <v-text-field
                      outlined
                      color="success"
                      label="Confirm new password"
                      v-model="confirmNewPassword"
                      :rules="confirmPasswordRules"
                      required
                      type="password"
                    />
                  </v-container>
                </v-form>
              </v-card-text>
              <v-divider />
              <v-card-actions>
                <v-spacer />
                <v-btn
                  @click="closeAndClear"
                  type="submit"
                  color="error"
                >
                  {{ changeDefaultPassword ? 'Later' : 'Cancel' }}
                </v-btn>
                <v-btn
                  @click="nextDialog()"
                  color="success"
                  :loading="loadingUpdate"
                  :disabled="loadingUpdate"
                >
                  Update
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog
            v-model="confirmDialog"
            persistent
            max-width="600"
          >
            <v-card
              dark
              color="warning"
            >
              <v-card-title>
                <span>
                  <v-icon>mdi-alert-circle</v-icon> Are you sure to want to
                  update your password?
                </span>
              </v-card-title>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  text
                  @click="confirmDialog = false"
                >
                  No
                </v-btn>
                <v-btn
                  text
                  @click="updatePassword()"
                >
                  Yes
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog
            v-model="successDialog"
            persistent
            max-width="500"
          >
            <v-card
              dark
              color="success"
            >
              <v-card-title>
                <span>
                  <v-icon>mdi-check-circle</v-icon> Success to update password!
                </span>
              </v-card-title>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  text
                  @click="successDialog = false"
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </v-toolbar-items>
    </v-app-bar>
  </div>
</template>
<script>
const merge = require("lodash/merge");
const get = require("lodash/get");

export default {
  data() {
    return {
      items: [],
      user_group_items: [
        { icon: "mdi-account-cog", title: "Management", to: "/user" },
        { icon: "mdi-account-check", title: "Approval", to: "/user_approval" },
      ],
      asset_group_items: [
        { icon: "mdi-application-cog", title: "Manager", to: "/asset_manager" },
        { icon: "mdi-application-settings", title: "Type", to: "/asset_type" },
        { icon: "mdi-account-multiple", title: "Group", to: "/asset_group" },
      ],
      booking_group_items: [
        { icon: "mdi-calendar-plus", title: "New", to: "/book" },
        { icon: "mdi-clipboard-list-outline", title: "Booking List", to: "/booking_list" },
        { icon: "mdi-calendar-clock", title: "Recurrence Booking Request", to: "/request" },
        { icon: "mdi-calendar", title: "Calendar", to: "/calendar" },
        { icon: "mdi-swap-horizontal", title: "Swap Vehicle", to: "/swop_vehicle", is_admin: true },
        { icon: "mdi-car-cog", title: "Vehicle Service", to: "/vehicle_service", is_admin: true },
      ],
      username: "",
      userType: this.$store.state.type,
      responsive: false,
      drawer: true,
      clipped: false,
      image:
        "https://demos.creative-tim.com/vue-material-dashboard/img/sidebar-2.32103624.jpg",
      dialog: false,
      valid: true,
      changeDefaultPassword: false,
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "",
      currentPasswordRules: [
        (value) => !!value || "Please type current password.",
      ],
      passwordRules: [
        (value) => !!value || "Please type password.",
        (value) => (value && value.length >= 6) || "Minimum 6 characters",
      ],
      confirmPasswordRules: [
        (value) => !!value || "Please type confirm password",
        (value) =>
          value === this.newPassword ||
          "The password confirmation does'nt match.",
      ],
      defaultPasswordAlertSession: null,
      confirmDialog: false,
      successDialog: false,
      model: 1,
      isError: false,
      errorMessage: "",
      loadingUpdate: false,
      loader: null,
      reqDataTotal: 0,
    };
  },
  watch: {
    loader() {
      const l = this.loader
      this[l] = !this[l]

      setTimeout(() => (this[l] = false), 3000)

      this.loader = null
    },
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
    setTimeout(() => {
      this.checkDefaultPassword();
    }, 2000);
    this.$nextTick(() => {
      setTimeout(() => {
        if (!this.$refs.hasOwnProperty('drawer-wrapper')) location.reload();
      }, 1e3)
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  created() {
    this.$store.dispatch("LOAD_COMPANY");
    this.setUsername();
    this.$store.commit('CLEAR_USER_APPROVAL_TOTAL');
    this.$store.dispatch("LOAD_USER_APPROVAL_TOTAL", { status: [0] });
    if (this.userData.user.type != 2 && this.userData.user.type != 4) {
      this.items = merge(this.items, [
        { icon: "mdi-domain", title: "Company Profile", to: "/company_profile" },
        { icon: "mdi-map-marker-radius", title: "Geofence", to: "/geofence" },
        { icon: "mdi-map-marker", title: "Popular Address Management", to: "/popular_address" },
        { icon: "mdi-email", title: "Email Template", to: "/email_template" },
        { icon: "mdi-menu", title: "Reports", to: "/reports" },
      ]);
    }
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    logoW() {
      return process.env.VUE_APP_LOGO_W;
    },
    maxWidth() {
      return process.env.VUE_APP_WEB === 'fleetpooling' ? 175 : 75;
    },
    getRequest() {
      const postData = {
        get_recurring: 1,
        get_schedules: 1,
        skip_past_date: 1,
      };
      const clientid = this.$store.state.clientid;
      if (this.$store.state.type == 2 || this.$store.state.type == 4) {
        postData.user_id = this.$store.state.user.user.id;
        postData.clientid = clientid;
        postData.get_request_join = 1;
        postData.status = [1, 3];
        // eslint-disable-next-line vue/no-async-in-computed-properties
        this.$store.dispatch('API_CALL', {
          $method: 'get_all_book',
          $postData: postData,
        }).then((response) => {
          this.reqDataTotal = response.data.data.length
        })
      } else if (this.$store.state.type == 1) {
        postData.clientid = clientid;
        postData.status = [1, 3];
        // eslint-disable-next-line vue/no-async-in-computed-properties
        this.$store.dispatch('API_CALL', {
          $method: 'get_all_book',
          $postData: postData,
        }).then((response) => {
          this.reqDataTotal = response.data.data.length
        })
      }
      return this.reqDataTotal
    },
    userTotal() {
      const total = this.$store.getters['getUserApprovalTotal']
      return parseInt(total)
    },
    user() {
      const { user = {} } = this.$store.getters["getUserData"];
      return user;
    },
    filteredItems() {
      const items = this.items.filter((item) =>
        item.to == "/user" ? this.userType == 1 || this.userType == 3 : true
      );
      return items;
    },
    getCompany() {
      return this.$store.getters.getCompanyData;
    },
    title() {
      return this.$route.name;
    },
    userData() {
      return this.$store.getters["getUserData"];
    },
    companyName() {
      const companyData = this.$store.getters.getCompanyData;
      return companyData.name;
    },
    isSSO() {
      const source = this.user.hasOwnProperty('source') ? this.user.source : false;
      if (source) return source.toLowerCase() === 'sso';
      return false;
    }
  },
  methods: {
    checkDefaultPassword() {
      this.changeDefaultPassword = false;
      const default_password = get(
        this.$store.state.user,
        "user.metadata.default_password",
        false
      );
      const alertDefaultPwd =
        default_password === "true" ||
        default_password === true ||
        default_password === 1;
      if (alertDefaultPwd && !this.user.hasOwnProperty('sso')) {
        const lastAlertToken = localStorage.getItem('defaultPasswordAlertSession');
        if (lastAlertToken !== this.$store.state.token) {
          localStorage.setItem('defaultPasswordAlertSession', this.$store.state.token);
          this.changeDefaultPassword = true;
          this.dialog = true;
        }
      }
    },
    updateUserDefaultPasswordFlag() {
      let userMetadata = {
        driver_license: {
          conditions: this.$store.state.user.user.metadata.driver_license
            .conditions,
          expiry_date: this.$store.state.user.user.metadata.driver_license
            .expiry_date,
          issuing_state: this.$store.state.user.user.metadata.driver_license
            .issuing_state,
          license_no: this.$store.state.user.user.metadata.driver_license
            .license_no,
          license_type: this.$store.state.user.user.metadata.driver_license
            .license_type,
        },
        photo: this.$store.state.user.user.metadata.photo,
        default_password: false,
      };

      const payloads2 = {
        metadata: userMetadata,
      };

      this.$store.commit('SET_DEFAULT_PASSWORD', false);
      this.changeDefaultPwd = false;
      this.$store.dispatch("UPDATE_USER", payloads2);
    },
    showThisPage(item) {
      const isShowGeneral = item.is_admin ? this.userType == 1 || this.userType == 3 : true
      return isShowGeneral;
    },
    logout() {
      const payloads = {
        token: this.$store.state.token,
      };
      this.$store.commit('SET_LOGOUT_FROM_BUTTON', true);
      return this.$store.dispatch("LOGOUT", payloads).then(() => {
        this.$router.push({ path: "/login" });
      });
    },
    myProfile() {
      this.$router.push({ path: "/my_profile" });
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    setUsername() {
      const patt = new RegExp("@");
      const res = patt.test(this.$store.state.name);
      if (res) {
        let username = this.$store.state.name.split("@");
        this.username = username[0].toUpperCase();
      } else {
        this.username = this.$store.state.name.toUpperCase();
      }
    },
    updatePassword() {
      this.confirmDialog = false;
      if (this.currentPassword === this.newPassword) {
        this.isError = true;
        this.errorMessage = 'New password cannot be the same as the current password!';
        return;
      }
      this.loadingUpdate = true;
      this.loader = this.loadingUpdate;

      const userId = this.$store.state.user.user.id;
      this.$store.dispatch('API_CALL', {
          $method: 'update_user_password',
          $postData: {
            id: userId,
            password: this.newPassword,
            old_password: this.currentPassword
          },
        })
        .then((response) => {
          if (response.data.code !== 200) {
            this.successDialog = false;
            this.isError = true;
            this.errorMessage = response.data.data.message;
            this.loadingUpdate = false;
            this.loader = this.loadingUpdate;
          } else {
            this.successDialog = true;
            this.dialog = false;
            this.isError = false;
            this.loadingUpdate = false;
            this.loader = this.loadingUpdate;
            if (this.changeDefaultPassword) {
              this.updateUserDefaultPasswordFlag();
            }
          }
        });
    },
    closeAndClear() {
      this.changeDefaultPassword = false;
      this.$refs.form.reset();
      this.dialog = false;
    },
    toUpdatePage() {
      this.$router.push({ path: "/company_profile" });
    },
    nextDialog() {
      if (this.$refs.form.validate()) {
        this.confirmDialog = true;
      }
    }
  },
};
</script>
<style>
.v-navv {
  border-left-color: 2px #00ACDC;
}
.item {
  cursor: pointer;
}
</style>
